// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Um-i","notes":"Notes_notes__QccnD"};